import { render } from "./App.vue?vue&type=template&id=d5af8478"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d5af8478&lang=css"
import "./App.vue?vue&type=style&index=1&id=d5af8478&lang=css"
import "./App.vue?vue&type=style&index=2&id=d5af8478&lang=css"

import exportComponent from "/home/runner/work/meedly-vueportfolio/meedly-vueportfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__